import { useEffect, useState } from 'react';

export function useIsDocumentVisible(): boolean {
    const [isDocumentVisible, setIsDocumentVisible] = useState<boolean>(!document.hidden);

    const handleVisibilityChange = () => {
        setIsDocumentVisible(!document.hidden);
    };

    useEffect(() => {
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    return isDocumentVisible;
}
